export const USER_MANAGEMENT_TITLE_TEST_ID = 'user-management-title';
export const USER_MANAGEMENT_NEW_USER_BUTTON_TEST_ID =
  'user-management-add-new-button';
export const USER_MANAGEMENT_TABLE_TEST_ID = 'user-management-table';
export const USER_MANAGEMENT_TABLE_ROW_TEST_ID =
  'user-management-table-row-entry';

export const USER_DETAILS_TEST_ID = 'user-management-details';
export const USER_DETAIL_DEACTIVATE_FEEDBACK_MODAL_TEST_ID =
  'user-details-deactivate-feedback-modal';
export const USER_DETAILS_DEACTIVATE_CONFIRM_MODAL_TEST_ID =
  'user-details-deactivate-confirm-modal';
export const USER_DETAILS_CLOSE_BUTTON_TEST_ID = 'user-details-close-button';
export const USER_DETAILS_DEACTIVATE_CONFIRM_BUTTON_TEST_ID =
  'user-management-details';
export const USER_DETAILS_DEACTIVATE_CANCEL_BUTTON_TEST_ID =
  'user-management-details';
export const USER_DETAILS_EDIT_BUTTON_TEST_ID = 'user-management-edit-button';
export const USER_DETAILS_DEACTIVATE_BUTTON_TEST_ID =
  'user-management-deactivate-button';

export const RESET_PASSWORD_MODAL_TEST_ID = 'reset-password-modal';
export const RESET_PASSWORD_BUTTON_TEST_ID = 'reset-password-button';

export const CONTACT_SUPPORT_EMAIL_TEST_ID =
  'user-management_contact-support_email-link';

export const NEW_USER_BUTTON_TEST_ID = 'new-user-button';
export const NEW_USER_DIALOG_TEST_ID = 'new-user-dialog';
export const NEW_USER_FEEDBACK_MODAL_TEST_ID = 'new-user-feedback-modal';
export const NEW_USER_FIRST_NAME_TEST_ID = 'new-user-last-name';
export const NEW_USER_LAST_NAME_TEST_ID = 'new-user-first-name';
export const NEW_USER_EMAIL_TEST_ID = 'new-user-email';
export const NEW_USER_ROLE_TEST_ID = 'new-user-role';
export const NEW_USER_ROLE_INFO_TEST_ID = 'new-user-role-info';
export const NEW_USER_CANCEL_TEST_ID = 'new-user-cancel';
export const NEW_USER_SUBMIT_TEST_ID = 'new-user-submit';

export const USER_ROLES_INFO = {
  operations_member:
    'Can manage day-to-day operational tasks including accounts, payouts, receivers, and withdrawals, but cannot review or approve payouts.',
  admin:
    'Full access to manage users, accounts, and all operational settings, but cannot review or approve payouts.',
  operations_member_reviewer:
    'Includes all Operations Member permissions and can additionally review and approve batch and manual payouts.',
  admin_reviewer:
    'Includes all Admin permissions and can additionally review and approve batch and manual payouts.',
  finance:
    'Read-only access with export and download permissions for financial reporting, reconciliation, and audits.',
  observer:
    'Read-only access to accounts, payouts, collections, and dashboard data with no ability to export, manage, or take action.',
  developer:
    'Can manage developer settings (authentication, webhooks, MCP tokens and business units), with read-only access to accounts, payouts, collections and dashboard data. Applies to Customer App access only — API operations are governed by API credentials.'
};
